"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("react-utils/debounce"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _Color = require("UIComponents/core/Color");

var _Fonts = require("UIComponents/utils/Fonts");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _NewFeatureShepherd = _interopRequireDefault(require("../shepherd/NewFeatureShepherd"));

var _functions = require("../../utils/functions");

var _iterables = require("../../utils/iterables");

var _toolbar = require("../../constants/toolbar");

var _newFeatures = require("../../constants/newFeatures");

var _ControlGroup = _interopRequireDefault(require("./ControlGroup"));

var _Disableable = _interopRequireDefault(require("./Disableable"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  height: 48px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: center;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  display: flex;\n  min-height: 48px;\n  justify-content: flex-start;\n  overflow: auto;\n  box-shadow: 0 1px 5px ", ";\n  user-select: none; /* needed to avoid the selection shifting to any element in the toolbar on mouse down */\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var i18nKey = function i18nKey(key) {
  return "RichTextLib." + key;
};

var RESPONSIVE_BUFFER = 60; // Because flexbox safe centering is not supported in anything other than FF
// https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content
// We need to set justify-content to flex-start and set auto margins on the first and last flex items

var StyledToolbar = _styledComponents.default.div.withConfig({
  displayName: "Toolbar__StyledToolbar",
  componentId: "sc-1hl4245-0"
})(_templateObject(), _colors.GYPSUM, (0, _Color.rgba)(_colors.PANTERA, 0.12));

var StyledInnerToolbar = _styledComponents.default.div.withConfig({
  displayName: "Toolbar__StyledInnerToolbar",
  componentId: "sc-1hl4245-1"
})(_templateObject2(), function (props) {
  return props.hasRows && 'flex-wrap: wrap';
}, function (props) {
  return props.centerControls && 'margin: 0 auto';
});

var StyledRow = _styledComponents.default.div.withConfig({
  displayName: "Toolbar__StyledRow",
  componentId: "sc-1hl4245-2"
})(_templateObject3());

var toolbarId = 0;

var getToolbarId = function getToolbarId() {
  return ++toolbarId;
};

var Toolbar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Toolbar, _Component);

  function Toolbar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Toolbar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Toolbar).call(this, props));
    _this.id = getToolbarId();
    _this.state = {
      toolbarWidth: 0,
      innerWidth: 0,
      controlRects: {},
      fontsLoaded: false
    };
    _this.toolbar = _this.props.toolbar;
    _this.hasRows = Array.isArray(_this.toolbar[0]);
    _this.controlRects = {};
    _this.rows = [];
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2.default)(_this));
    _this.collectControlRect = _this.collectControlRect.bind((0, _assertThisInitialized2.default)(_this));
    _this.getInnerWidth = _this.getInnerWidth.bind((0, _assertThisInitialized2.default)(_this));
    _this.getToolbarWidth = _this.getToolbarWidth.bind((0, _assertThisInitialized2.default)(_this));
    _this.getResponsiveToolbar = (0, _functions.memoize)(_this.getResponsiveToolbar, function (toolbarWidth, innerWidth) {
      return toolbarWidth + ":" + innerWidth;
    });
    _this.controlsCollected = (0, _debounce.default)(_this.controlsCollected.bind((0, _assertThisInitialized2.default)(_this)), 100);
    _this.renderControlGroup = _this.renderControlGroup.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Toolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        toolbarWidth: this.getToolbarWidth()
      });
      window.addEventListener('resize', this.handleResize);
      this.initResponsiveToolbar();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "initResponsiveToolbar",
    value: function initResponsiveToolbar() {
      var _this2 = this;

      _Fonts.iconFontsLoadedPromise.then(function () {
        _this2.setState({
          fontsLoaded: true
        }, function () {
          _this2.handleResize();
        });
      });
    }
  }, {
    key: "getNewToolbar",
    value: function getNewToolbar() {
      var mapGroup = function mapGroup(group) {
        return (0, _extends2.default)({}, group, {
          controls: group.controls.map(function (control) {
            return (0, _extends2.default)({}, control);
          })
        });
      };

      if (this.hasRows) {
        return this.toolbar.map(function (row) {
          return row.map(mapGroup);
        });
      }

      return this.toolbar.map(mapGroup);
    }
  }, {
    key: "getToolbarWidth",
    value: function getToolbarWidth() {
      return this.node.offsetWidth - RESPONSIVE_BUFFER;
    }
  }, {
    key: "getInnerWidth",
    value: function getInnerWidth() {
      return Math.max.apply(Math, (0, _toConsumableArray2.default)(this.rows.map(function (_ref) {
        var offsetWidth = _ref.offsetWidth;
        return offsetWidth;
      })));
    }
  }, {
    key: "getResonsiveGroupIndex",
    value: function getResonsiveGroupIndex(toolbar, collapsedGroups) {
      var responsiveGroupIndex;
      var priority = Infinity;
      var responsiveRow = this.hasRows ? toolbar[0] : toolbar;
      responsiveRow.forEach(function (group, index) {
        var _group$responsivePrio = group.responsivePriority,
            responsivePriority = _group$responsivePrio === void 0 ? Infinity : _group$responsivePrio;

        if (responsivePriority < priority && !collapsedGroups[index]) {
          priority = responsivePriority;
          responsiveGroupIndex = index;
        }
      });
      return responsiveGroupIndex;
    }
  }, {
    key: "getCollapsedGroup",
    value: function getCollapsedGroup(widthDelta, group) {
      var _this3 = this;

      var controls = group.controls,
          boundary = group.boundary;
      var threshold = true;
      var controlCount = 1;
      var newControls = [];
      var controlWidths = 0;

      while (threshold) {
        newControls = controls.slice(controls.length - (controlCount + 1), controls.length - 1);
        var isBoundary = controls.length - (controlCount + 2) <= boundary;
        controlWidths = newControls.reduce(function (acc, _ref2) {
          var control = _ref2.control;
          var _this3$controlRects$c = _this3.controlRects[control],
              width = _this3$controlRects$c.width,
              marginLeft = _this3$controlRects$c.marginLeft;
          return acc + width + marginLeft;
        }, 0);

        if (controlWidths > widthDelta || isBoundary) {
          threshold = false;
        } else {
          controlCount++;
        }
      }

      var menu = controls[controls.length - 1];
      var newItems = (controls.slice(controls.length - (1 + controlCount), controls.length - 1) || []).map(function (el) {
        return el.control;
      });

      if (this.hasRows) {
        menu.menuItems = [].concat((0, _toConsumableArray2.default)(menu.menuItems), (0, _toConsumableArray2.default)(newItems));
      } else {
        menu.menuItems = [].concat((0, _toConsumableArray2.default)(newItems), (0, _toConsumableArray2.default)(menu.menuItems));
      }

      return {
        controls: [].concat((0, _toConsumableArray2.default)(controls.slice(0, controls.length - (controlCount + 1))), [menu]),
        controlWidths: controlWidths
      };
    }
  }, {
    key: "getResponsiveToolbar",
    value: function getResponsiveToolbar(toolbarWidth, innerWidth) {
      var collapsedGroups = {};
      var groupControlWidths = 0;
      var collapsed = false;
      var widthDelta = innerWidth - toolbarWidth;

      if (!innerWidth || widthDelta < 0) {
        return this.toolbar;
      }

      var responsiveToolbar = this.getNewToolbar(this.toolbar);
      var responsiveRow = this.hasRows ? responsiveToolbar[0] : responsiveToolbar;

      while (groupControlWidths < widthDelta && !collapsed) {
        var responsiveGroupIndex = this.getResonsiveGroupIndex(this.toolbar, collapsedGroups);

        if (responsiveGroupIndex) {
          var _this$getCollapsedGro = this.getCollapsedGroup(widthDelta - groupControlWidths, responsiveRow[responsiveGroupIndex]),
              controls = _this$getCollapsedGro.controls,
              controlWidths = _this$getCollapsedGro.controlWidths;

          collapsedGroups[responsiveGroupIndex] = controls;
          groupControlWidths += controlWidths;
        } else {
          collapsed = true;
        }
      }

      Object.keys(collapsedGroups).forEach(function (collapsedGroupIndex) {
        responsiveRow[collapsedGroupIndex] = (0, _extends2.default)({}, responsiveRow[collapsedGroupIndex], {
          controls: collapsedGroups[collapsedGroupIndex]
        });
      });
      return responsiveToolbar;
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var innerWidth = this.state.innerWidth;
      var toolbarWidth = this.getToolbarWidth();

      if (this.innerToolbar && !this.state.innerWidth) {
        innerWidth = this.getInnerWidth();
      }

      if (this.state.toolbarWidth && !this.state.innerWidth) {
        this.setState({
          innerWidth: innerWidth
        });
      }

      if (this.state.toolbarWidth !== toolbarWidth) {
        this.setState({
          toolbarWidth: toolbarWidth
        });
      }

      if (innerWidth === 0 && this.innerToolbar) {
        window.requestAnimationFrame(this.handleResize);
      }
    }
  }, {
    key: "controlsCollected",
    value: function controlsCollected() {
      if (Object.keys(this.state.controlRects).length !== Object.keys(this.controlRects).length) {
        this.setState({
          controlRects: this.controlRects
        });
      }
    }
  }, {
    key: "collectControlRect",
    value: function collectControlRect(control, boundingRect) {
      this.controlRects[control] = boundingRect;
      this.controlsCollected();
    }
  }, {
    key: "renderControlGroup",
    value: function renderControlGroup(_ref3, index) {
      var controls = _ref3.controls;
      var _this$props = this.props,
          centerControls = _this$props.centerControls,
          dropdownClassName = _this$props.dropdownClassName,
          convertToButton = _this$props.convertToButton,
          convertToMenuItem = _this$props.convertToMenuItem,
          onMoreMenuOpenComplete = _this$props.onMoreMenuOpenComplete;
      return _react.default.createElement(_ControlGroup.default, {
        key: "toolbar-" + this.id + "-control-group-" + index,
        controls: controls,
        dropdownClassName: dropdownClassName,
        centerControls: centerControls,
        convertToButton: convertToButton,
        convertToMenuItem: convertToMenuItem,
        collectControlRect: this.collectControlRect,
        onMoreMenuOpenComplete: onMoreMenuOpenComplete,
        toolbarWidth: this.state.toolbarWidth
      });
    }
  }, {
    key: "renderToolbar",
    value: function renderToolbar(toolbar) {
      var _this4 = this;

      if (this.hasRows) {
        return toolbar.map(function (row, index) {
          return _react.default.createElement(StyledRow, {
            innerRef: function innerRef(el) {
              return _this4.rows[index] = el;
            },
            key: "toolbar-" + _this4.id + "-row-" + index
          }, row.map(_this4.renderControlGroup));
        });
      }

      return _react.default.createElement(StyledRow, {
        innerRef: function innerRef(el) {
          return _this4.rows[0] = el;
        },
        key: "toolbar-" + this.id + "-row-" + 1
      }, toolbar.map(this.renderControlGroup));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var centerControls = this.props.centerControls;
      var toolbar;

      if (this.state.toolbarWidth) {
        toolbar = this.getResponsiveToolbar(this.state.toolbarWidth, this.state.innerWidth);
      }

      var styledToolbar = _react.default.createElement(_Disableable.default, {
        disabled: this.props.disabled,
        toolbarTooltip: this.props.toolbarTooltip
      }, _react.default.createElement(StyledToolbar, {
        "data-test-id": "canvas-toolbar",
        innerRef: function innerRef(node) {
          return _this5.node = node;
        },
        className: this.props.className,
        key: "toolbar-" + this.id
      }, _react.default.createElement(StyledInnerToolbar, {
        hasRows: this.hasRows,
        centerControls: centerControls,
        innerRef: function innerRef(el) {
          return _this5.innerToolbar = el;
        }
      }, toolbar !== undefined && this.renderToolbar(toolbar))));

      if (this.props.showToolbarShepherd) {
        return _react.default.createElement(_NewFeatureShepherd.default, {
          placement: "bottom right",
          settingsKey: _newFeatures.HAS_DISMISSED_TOOLBAR_NO_UNDO,
          className: this.props.shepherdClassName,
          getUserAttributes: this.props.getUserAttributes,
          setUserAttribute: this.props.setUserAttribute,
          header: _react.default.createElement(_FormattedMessage.default, {
            message: i18nKey('newFeatures.noToolbarUndo.header')
          }),
          body: _react.default.createElement(_FormattedMessage.default, {
            message: i18nKey('newFeatures.noToolbarUndo.body')
          })
        }, styledToolbar);
      }

      return styledToolbar;
    }
  }]);
  return Toolbar;
}(_react.Component);

exports.default = Toolbar;

var toolbarRowPropType = _react.PropTypes.arrayOf(_react.PropTypes.shape({
  controls: _react.PropTypes.arrayOf(_toolbar.controlPropType).isRequired,
  boundary: _react.PropTypes.number,
  responsivePriority: _react.PropTypes.number
}));

Toolbar.propTypes = {
  toolbar: _react.PropTypes.oneOfType([toolbarRowPropType, _react.PropTypes.arrayOf(toolbarRowPropType)]).isRequired,
  convertToMenuItem: _react.PropTypes.func.isRequired,
  convertToButton: _react.PropTypes.func.isRequired,
  onMoreMenuOpenComplete: _react.PropTypes.func,
  dropdownClassName: _react.PropTypes.string,
  className: _react.PropTypes.string,
  centerControls: _react.PropTypes.bool,
  shepherdClassName: _react.PropTypes.string,
  getUserAttributes: _react.PropTypes.func,
  setUserAttribute: _react.PropTypes.func,
  showToolbarShepherd: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  toolbarTooltip: _react.PropTypes.string
};
Toolbar.defaultProps = {
  centerControls: false,
  convertToButton: _iterables.identity,
  convertToMenuItem: _iterables.identity,
  showToolbarShepherd: false,
  disabled: false
};
module.exports = exports.default;